import React, { useEffect, useState, useRef } from "react";

const Counter = ({ target, duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const [startAnimation, setStartAnimation] = useState(false);
  const counterRef = useRef(null);


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartAnimation(true); // Trigger animation when visible
        }
      },
      { threshold: 0.5 } // Adjust threshold as needed
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!startAnimation) return;

    let start = 0;
    const increment = target / (duration / 50);

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        clearInterval(timer);
        setCount(target); // Ensure the final value matches the target
      } else {
        setCount(Math.ceil(start));
      }
    }, 50);

    return () => clearInterval(timer); // Cleanup interval on unmount
  }, [startAnimation, target, duration]);

  return (
    <div ref={counterRef} data-aos-once="true">
      <span className="counter" >
        {count}
      </span>
    </div>
  );
};

export default Counter;
